import { shallowRef } from 'vue';

const translations = shallowRef({});

export const setTranslations = (data = {}) => {
  translations.value = data;
};

export const t = (key, values = null) => {
  if (!key) return '';

  const translation = translations.value?.[key] ?? key;
  if (!values) return translation;

  return translation.replace(/\{\{\s*(\w+)\s*\}\}/g, (match, k) => values[k.trim()] ?? match);
};
